module.exports = __webpack_public_path__ + "img/de.88500c80.svg";